export default __webpack_public_path__ + "static/media/a023-startup1-en.c792f6ad.png";